import { render, staticRenderFns } from "./InvestigationPerson.vue?vue&type=template&id=e577e392&"
import script from "./InvestigationPerson.vue?vue&type=script&lang=js&"
export * from "./InvestigationPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports